import { useQuery } from '@tanstack/react-query';

import { NotificationHistoryEntry } from '@/features/notification-history/types/notification-history-entry';
import { artiaProtectedApi } from '@/lib/api-client';

export const notificationHistoryQueryKey = ['notification-history'];

const getNotificationHistory = (): Promise<NotificationHistoryEntry[]> => {
  return artiaProtectedApi.get('admin/notification-history');
};

export const useNotificationHistoryQuery = () => {
  return useQuery({
    queryKey: notificationHistoryQueryKey,
    queryFn: getNotificationHistory
  });
};
